import { endpoints, request } from '!core/api';

export const trlTopInstrumentsServices = {
  wsbGetInstrGroupsWithTops: () =>
    request.get(endpoints.chnn('wsbGetInstrGroupsWithTops')),
  wsbGetTopQuotes: ({ instrumentTopGroup }) =>
    request.get(
      endpoints.chnn(`wsbGetTopQuotes?instrumentGroup=${instrumentTopGroup}`),
    ),
};
